export const form = [
      {
            name: 'customer_id',
            value: [],
            valueFull: '',
            id: 'retailDeleted_form_customer_id',
            html: '',
            type: 'autocomplete',
            required: false,
      },
      {
            name: 'sale_date',
            value: '0000-00-00',
            date: true,
            id: 'retailDeleted_form_sale_date',
            html: '',
            type: 'textfield',
            required: false,
      },
      {
            name: 'accounts_id',
            value: [],
            valueFull: '',
            id: 'retailDeleted_form_accounts_id',
            html: '',
            type: 'autocomplete',
            required: false,
      },
      {
            name: 'payment_method',
            value: '',
            id: 'retailDeleted_form_payment_method',
            html: '',
            type: 'multiselect',
            options: ['Bank Transfer', 'ACH', 'Wire', 'Check', 'Cash', 'Zelle', 'Other'],
            required: false,
      },
      {
            name: 'tax_percentage',
            value: '0.00',
            id: 'retailDeleted_form_tax_percentage',
            html: '',
            type: 'textfield',
            required: false,
      },
      {
            name: 'grand_total',
            value: '',
            id: 'retailDeleted_form_grand_total',
            html: '',
            type: 'textfield',
            required: false,
      },
]

export const formCopy = JSON.parse(JSON.stringify(form))
